import type {
    NormalizeOrganizationServiceSourceFromApiParams,
    OrganizationServiceSource,
} from '../types';
import throwUnsupportedOrganizationService from './throwUnsupportedOrganizationService';

const normalizeOrganizationServiceSourceFromApi = ({
    source,
}: NormalizeOrganizationServiceSourceFromApiParams): OrganizationServiceSource => {
    if (typeof source !== 'object' || source === null) {
        return throwUnsupportedOrganizationService({});
    }

    const sourceRecord = source as {
        availability?: unknown;
        playbookIds?: unknown;
    };

    if (sourceRecord.availability !== 'available' && sourceRecord.availability !== 'archived') {
        return throwUnsupportedOrganizationService({});
    }

    if (!Array.isArray(sourceRecord.playbookIds)) {
        return throwUnsupportedOrganizationService({});
    }

    const playbookIds = sourceRecord.playbookIds.map(playbookId => {
        if (typeof playbookId !== 'string') {
            return throwUnsupportedOrganizationService({});
        }
        return playbookId;
    });

    return {
        availability: sourceRecord.availability,
        playbookIds,
    };
};

export default normalizeOrganizationServiceSourceFromApi;
